import {
  footer_item_styles_default
} from "./chunk.GZ376QHN.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/footer-item/footer-item.ts
var FadvFooterItem = class extends s {
  render() {
    return $`<fadv-typography class="footer-item" type="label-small"><fadv-button variant="text" href=${l(this.href)} target=${l(this.target)} download=${l(this.download)} ><slot></slot ></fadv-button></fadv-typography>`;
  }
};
FadvFooterItem.styles = footer_item_styles_default;
__decorateClass([
  e()
], FadvFooterItem.prototype, "href", 2);
__decorateClass([
  e()
], FadvFooterItem.prototype, "target", 2);
__decorateClass([
  e()
], FadvFooterItem.prototype, "download", 2);
FadvFooterItem = __decorateClass([
  n("fadv-footer-item")
], FadvFooterItem);

export {
  FadvFooterItem
};
